import styled from 'styled-components';

import { Modal } from '@material-ui/core';

export const CustomModal = styled(Modal)`
  display: flex;
  justify-content: center;
  align-items: center;

  h2 {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: var(--color-navy-blue);
  }

  > div.body {
    min-width: 300px;
    position: relative;
    background: #fff;
    padding: 20px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    display: flex;
    justify-content: center;
    gap: 24px;
    max-height: 90vh;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h1 {
    color: var(--color-navy-blue);
    font-size: 20px;
    text-align: center;
    font-weight: 800;
    margin-top: 15px;
    font-family: 'Sora', sans-serif;
  }

  button {
    font-family: Sora, sans-serif;
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: rgba(215, 222, 233, 0.25);
    svg {
      color: #4f4f4f;
      font-size: 22px;
    }
    &:hover {
      background-color: rgba(215, 222, 233, 0.5);
    }
  }
`;

export const ModalBody = styled.div`
  .google-automcomplete {
    width: 350px;
    max-width: 90vw;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .MuiAutocomplete-root {
      width: 100%;
      min-width: 300px;
      padding-top: 5px;
    }

    .MuiFormLabel-root {
      color: var(--color-alba-grandeza);
      font-weight: 400;
      font-family: 'Sora';
      font-size: 14px;
    }

    .MuiFormLabel-root.Mui-focused {
      color: var(--color-blue) !important;
    }

    .MuiOutlinedInput-notchedOutline {
      border: 2px solid var(--color-gray-900);
    }

    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: var(--color-blue) !important;
    }

    .MuiInputBase-input {
      color: var(--color-alba-grandeza) !important;
    }
  }

  form {
    width: 350px;
    max-width: 90vw;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 1px 0px;

    .formulary {
      overflow-y: auto;
      max-height: 50vh;
      padding-right: 4px;

      display: flex;
      flex-direction: column;
      gap: 12px;

      scrollbar-width: thin;
      scrollbar-color: black transparent;

      &::-webkit-scrollbar {
        width: 3px;
        height: 3px;
      }

      &::-webkit-scrollbar-track {
        background: transparent;
        padding: 2px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #a1a1a1;
      }
    }

    .buttons {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
  }

  .map {
    width: 500px;
    max-width: 90vw;
    display: flex;
    flex-direction: column;
    gap: 12px;

    #map-create-address {
      width: 100%;
      min-height: 300px;
      border-radius: 5px;
      border: 2px solid var(--color-gray-900);
    }

    .buttons {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .gm-svpc,
    .gm-style-mtc {
      display: none;
    }
  }
`;
